import { observer, inject } from "mobx-react";
import { Text } from "../UI";
import { addMonths, format, subMonths } from "date-fns";
import { he } from "date-fns/locale";
import backImg from "../asserts/img/arrowLeft.svg";
import forwordImg from "../asserts/img/arrowRight.svg";
import { useMobile } from "../utils/mobile";
import { useTranslation } from "react-i18next";

// Controlled: shows the month in `startDate` (owned by the page) and reports changes
const MonthPicker = ({ handleDateChange, startDate = new Date() }) => {
  const date = startDate;
  const isMobile = useMobile();
  const { i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";

  const subMonth = (date) => {
    const newDate = subMonths(date, 1);
    handleDateChange(newDate);
  };

  const addMonth = (date) => {
    const newDate = addMonths(date, 1);
    handleDateChange(newDate);
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: isRtl ? "row" : "row-reverse",
        justifyContent: "space-between",
        alignItems: "center",
      }}>
      <img
        alt="forward"
        src={forwordImg}
        onClick={() => subMonth(date)}
        style={{ paddingInlineEnd: 20 }}
      />
      <Text
        style={{
          fontWeight: 500,
          fontSize: isMobile ? 16 : 20,
        }}>
        {`${format(new Date(date), "LLLL", { locale: he })} ${format(
          new Date(date),
          "yyyy",
          { locale: he }
        )}`}
      </Text>
      <img
        alt="back"
        src={backImg}
        onClick={() => addMonth(date)}
        style={{ paddingInlineStart: 20 }}
      />
    </div>
  );
};

export default inject()(observer(MonthPicker));
